// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	/**
	* Back to top button
	*/

	//Get the button
	let toTopButton = document.getElementById("toTopBtn");

	// When the user scrolls down 20px from the top of the document, show the button
	window.onscroll = function () {
		scrollFunction();
	};

	function scrollFunction() {
		if (
			document.body.scrollTop > 20 ||
			document.documentElement.scrollTop > 20
		) {
			toTopButton.style.display = "block";
		} else {
			toTopButton.style.display = "none";
		}
	}

	// When the user clicks on the button, scroll to the top of the document
	toTopButton.addEventListener("click", backToTop);

	function backToTop() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}

	/**
	* Search controls
	*/

	// Trigger button click on Enter when button focused
	var input = document.getElementById("search_button");
		input.addEventListener("keyup", function(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
		document.getElementById("search_button").click();
		}
	});

	// Open the search overlay
	let searchButton = document.getElementById("search_button");
	searchButton.addEventListener("click", openSearchBox);

	function openSearchBox() {
		document.getElementById("search_overlay").style.display = "block";
		document.getElementById("search_input").focus();
	}

	// Close the search overlay if the search overlay or the close button have been clicked
	$('#search_overlay').on('click', function (e) {
		if ( (e.target.id == "search_overlay") || (e.target.id == "close_search_button") ) {
			closeSearchBox();
		}
	});	
	
	// Close if the Escape key has been pressed
	$(document).keyup(function(e) {
		if ( (e.key === "Escape") && (!isHidden("search_overlay")) ) { // escape key maps to keycode `27`
			closeSearchBox();
	   }
	});

   // Check if an element is hidden
   function isHidden(el) {
	   var x = document.getElementById(el);
	   if (window.getComputedStyle(x).display === "none") {
		 return true;
	   }
	}

	// Exit the search overlay
	function closeSearchBox() {
		document.getElementById("search_overlay").style.display = "none";
	}

	/**
	*  Focus input if Searchform is empty
	*/

	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	/**
	*  Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	*/

	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();